import { render, staticRenderFns } from "./show-archived.component.vue?vue&type=template&id=4ac0ee6f&"
import script from "./show-archived.component.vue?vue&type=script&lang=js&"
export * from "./show-archived.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports